import React, { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { AppbarContentContext } from "components/commons/routing/appbar/AppbarContentProvider";
import GameSessionRunningTime from "../game-session/GameSessionRunningTime";
import GameSessionPointStop from "../game-session/GameSessionPointStop";
import Playlist from "../playlist/Playlist";
import { useStyles } from "./GameSessionSectionStyles.css";
import { FormattedMessage } from "react-intl";
import associationStructure from "../../../../commons/associationStructure/associationStructure.json";
/*
    Parent component for all the different game session components
    Based on the discipline, a different game session will be loaded, with its corresponding
    scoreboards and point systems.
 */

const GameSessionSection = () => {
    const classes = useStyles();

    const location = useLocation();
    const currentVideo = location.state.gameSessionInfo;
    const playlistInfo = location.state.playlistInfo;
    const type = "regular";

    const { setCurrentAppbarContent } = useContext(AppbarContentContext);

    useEffect(() => {
        setCurrentAppbarContent({
            header: (
                <FormattedMessage
                    id={"app.game.session.section.appbar.header"}
                    defaultMessage={"Game Session"}
                />
            ),
            description: playlistInfo.playlistName,
            actions: <></>,
        });
    }, []);

    const gameSessionPointStop = (
        <GameSessionPointStop
            currentVideo={currentVideo}
            playlistInfo={playlistInfo}
        />
    );

    const gameSessionRunningTime = (
        <GameSessionRunningTime
            currentVideo={currentVideo}
            playlistInfo={playlistInfo}
        />
    );


    function determineSessionType() {
        if (currentVideo.sessionProperties.sessionMode === "running_time") {
            return gameSessionRunningTime;
        }
        if (currentVideo.sessionProperties.sessionMode === "point_stop") {
            return gameSessionPointStop;
        }
    }

    return (
        <div className={classes.sessionContainer}>
            {determineSessionType()}
        </div>
    );
};

export default GameSessionSection;
